<template>
  <smd-one-col-layout class="d-root-pharmacy-orders"
                      content-styles="full-width d-root-pharmacy-orders__content">
    <smd-header class="top-bar-box-shadow" slot="header" nav>
      <span class="ns-icon-ico027"
            slot="right-actions"
            @click="goBack"/>
      <text-string label-id="txt070"/>
      <!--      <span class="ns-icon-ico001"-->
      <!--            slot="right-actions">-->
      <!--        <span class="path1"></span>-->
      <!--        <span class="path2"></span>-->
      <!--      </span>-->
    </smd-header>
    <smd-two-col-layout class="d-root-pharmacy-orders__two-col"
                        sidebar-styles="d-root-pharmacy-orders__two-col__sidebar">
      <smd-one-col-layout class="d-root-pharmacy-orders__step"
                          content-styles="d-root-pharmacy-orders__step__content"
                          slot="sidebar">
        <smd-step-progress class="m-t-10"
                           horizontal
                           :options="computedSteps"
                           :current-step="activeStep"/>
      </smd-one-col-layout>

      <component class="d-root-pharmacy-orders__form"
                 slot="content"
                 desktop-view
                 :is="activeComponent"
                 @set-active-step="setActiveStep"/>
    </smd-two-col-layout>
  </smd-one-col-layout>
</template>

<script>
  import RootPharmacyOrdersMixin from './root-pharmacy-orders-mixin';

  export default {
    name: "d-root-pharmacy-orders-new",
    mixins: [RootPharmacyOrdersMixin]
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .d-root-pharmacy-orders__content {
    background: color(light, border);
  }

  .d-root-pharmacy-orders__two-col {
    @include make-grid-cols(minmax(0, 265px) 1fr);
    @include responsive('max-width: 1023px') {
      margin-left: 0;
    }
    @include responsive('min-width: 1800px') {
      grid-template-columns: 0 1fr;
    }
    background: color(light, border);
    margin-left: space(xl);
  }

  .d-root-pharmacy-orders__two-col__sidebar {
    max-width: 265px;
    width: 100%;
  }

  .d-root-pharmacy-orders__step__content {
    padding-top: space(xl) !important;

    @include responsive('min-width: 1800px') {
      position: fixed;
      width: 250px;
      z-index: 10000;
    }
  }

  .d-root-pharmacy-orders__step {
    max-width: 265px;
    width: 100%;
  }
</style>